module.exports = __webpack_public_path__ + "img/stars.0727bc1c.png";